import { createSelector } from "@reduxjs/toolkit";

import { RootState } from "Store/configureStore";

import type { ProjectAccess } from "@packages/client";

export interface ProjectAccesses {
  [userId: string]: ProjectAccess;
}

interface SelectorProps {
  organizationId: string;
  projectId: string;
}

export const selectProjectAccesses = createSelector(
  [
    (state: RootState) => state.projectAccess,
    (_, props: SelectorProps) => props
  ],
  (projectAccess, props) =>
    projectAccess.data[props.organizationId]?.[props.projectId] || []
);

export const selectEmailsFromProjectAccesses = createSelector(
  selectProjectAccesses,
  projectAccesses => projectAccesses.map(p => p?.getUser().email)
);

export const projectAccessCountSelector = createSelector(
  selectProjectAccesses,
  projectAccesses => projectAccesses.length
);
